import steps from "../registration/components/steps";

export const setStep = (currentStep) => {
    const step = steps.find((step) => step.stepId === currentStep);
    localStorage.setItem("currentStep", JSON.stringify(step));
}

export const getStep = () => {
    const currentStep = JSON.parse(localStorage.getItem("currentStep"));
    return currentStep;
}

export const removeStep = () => {
    localStorage.removeItem("currentStep");
};